import styled from 'styled-components'
import { motion } from 'framer-motion'
export const StyledContent = styled(motion.div)`
  z-index: 200;
  flex: 1;
  width: 100%;
  max-width: 1024px;
  margin-bottom: 1rem;
  padding:1rem;
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'column'};
  align-items: center;
  justify-content: center;
  align-self: center;
`
